import axiosInstance from './axiosConfig';

export const getClubsApi = (params) => axiosInstance.get('/clubs', { params });
export const getClubApi = (id) => axiosInstance.get(`/clubs/${id}`);
export const createClubApi = (payload) => axiosInstance.post('/clubs', payload);
export const updateClubApi = (id, payload) => axiosInstance.put(`/clubs/${id}`, payload);
export const updateClubStatusApi = (id, status) =>
  axiosInstance.put(`/clubs/${id}/status`, { status });
export const deleteClubApi = (id) => axiosInstance.delete(`/clubs/${id}`);
export const uploadClubLogoApi = (id, file) => {
  const formData = new FormData();
  formData.append('logo', file);
  return axiosInstance.post(`/clubs/${id}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getMyClubProfileApi = () => axiosInstance.get('/clubs/my-profile');
export const updateMyClubProfileApi = (payload) => axiosInstance.put('/clubs/my-profile', payload);